// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminSweepRunResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminSweepRunResponse — result of POST /subscriptions/admin/sweep/run
 * (S12/#17a: the staff-triggered whole round).
 *
 * REPORTS AN OUTCOME, NEVER A REFUSAL. Everything here describes a round that
 * RAN. The only things that leave the endpoint through sendError() are the auth
 * gate and an unexpected exception — never a business result, because every
 * business result of a sweep is information the staff asked for.
 *
 * circuit_open=true is the sharpest case of that rule: the breaker refusing the
 * round is the mechanism working, and it arrives as success=true with
 * cancelled_count=0. Modelling it as an error would train the console to show a
 * red toast for the one outcome a human most needs to read carefully.
 *
 * The five counters do not overlap and, on a round where the breaker stayed
 * shut, cancelled+deferred+refused+failed === candidate_count:
 *   cancelled_count — the provider cancelled it and the local row followed
 *   deferred_count  — the provider still has a payment retry scheduled
 *   refused_count   — no reachable gateway (unregistered adapter, or one that
 *                     does not declare cancel_subscription)
 *   failed_count    — gateway_failed + local_write_failed
 *   candidate_count — how many rows the predicate found due
 *
 * cutoff is the end-of-day boundary the round cut against (S12/M3: a franchise
 * keeps the whole calendar day its window closes on), emitted as ISO 8601 UTC
 * like every other datetime on the wire — it is a GMT-3 midnight, so it renders
 * as the previous day at 03:00Z.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_AdminSweepRunResponseDados {
cancelled_count: number
cancelled_ids: number[]
deferred_count: number
refused_count: number
failed_count: number
candidate_count: number
circuit_open: boolean
cutoff: string
}

export type Subscriptions_AdminSweepRunResponse = ApiResponse<Subscriptions_AdminSweepRunResponseDados>;

registerResponseContract('Subscriptions_AdminSweepRunResponse', {
  cancelled_count: { type: 'number',  required: true },
  cancelled_ids:   { type: 'array',   required: true },
  deferred_count:  { type: 'number',  required: true },
  refused_count:   { type: 'number',  required: true },
  failed_count:    { type: 'number',  required: true },
  candidate_count: { type: 'number',  required: true },
  circuit_open:    { type: 'boolean', required: true },
  cutoff:          { type: 'string',  required: false },
})
